import React from 'react';

import DoneIcon from '@mui/icons-material/Done';
import { company } from '@components/config/Company';

function OurFleet() {
  const areasCovered = [
    'Birmingham',
    'Solihull',
    'Yardley',
    'Bickerhill',
    'Accoks Green',
    'Earlswood',
    'Barston',
    'Knowle',
    'Dorridge',
    'Hatton',
    'Sparkhill',
    'Dickens Heath',
    'Hockley Heath',
    'Chadwick End',
    'Kenilworth',
    'Birmingham Airport',
    'Shirley',
    'Hall Green',
  ];
  return (
    <div>
      <div className="bg-secondary py-9">
        <div className="text-center font-light text-xl sm:text-2xl xl:text-4xl">
          Our <b>Fleet</b>
        </div>
      </div>
      <div className="grid grid-cols-1 paddingClass lg:grid-cols-3">
        <div className="col-span-1 pr-2 my-5 lg:col-span-2 lg:pr-10">
          <div>
            <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
              Birmingham & Solihull’s Largest Private Hire Taxi Base
            </div>
            <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
              247 Radio Cars boasts a large fleet of vehicles that can fulfil
              the travel needs for any journey or event. From new modern private
              taxis to executive cars and wedding limousines, we have it all.
              <br />
              <br />
              We believe that any journey or event should be done in complete
              comfort and style. Our expansive fleet of modern private taxis to
              executive cars and luxurious wedding limousines ensure the perfect
              travel experience by providing passengers with utmost peace,
              classiness & safety. All vehicles are meticulously kept in top
              shape - so you can rest easy knowing your trip will be a breeze.
            </div>
          </div>
          <div className="grid grid-cols-1 my-8 lg:grid-cols-2">
            <div className="px-8 py-5 bg-light/50">
              <div className="my-8 font-light  text-gray text-base sm:text-lg lg:text-xl 2xl:text-2xl">
                Our drivers are great for . . .{' '}
              </div>
              <div className="flex items-center gap-2 my-2">
                <DoneIcon className="text-2xl text-secondary" />
                <div className="text-gray font-light text-base sm:text-lg">
                  Weddings
                </div>
              </div>
              <div className="flex items-center gap-2 my-2">
                <DoneIcon className="text-2xl text-secondary" />
                <div className="text-gray font-light text-base sm:text-lg">
                  Uncommon Occasions
                </div>
              </div>
              <div className="flex items-center gap-2 my-2">
                <DoneIcon className="text-2xl text-secondary" />
                <div className="text-gray font-light text-base sm:text-lg">
                  Airport terminal Transfers
                </div>
              </div>
              <div className="flex items-center gap-2 my-2">
                <DoneIcon className="text-2xl text-secondary" />
                <div className="text-gray font-light text-base sm:text-lg">
                  Business Trips
                </div>
              </div>
            </div>
            <div className="px-8 py-5 bg-gray/40">
              <div className="my-8 font-light text-gray text-base sm:text-lg lg:text-xl 2xl:text-2xl">
                Book Your Taxi {company[0]?.tel_number}
              </div>
              <div className="text-justify text-gray font-light text-base sm:text-lg lg:text-xl 2xl:text-2xl">
                With more than 20 years in the transportation business, we have
                a vehicle for each conceivable trip.
                <br />
                <br />
                Our expert team is made up of extraordinary drivers who make it
                their goal to guarantee your trip goes as easily as it can.
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center p-4 bg-primary">
          <div className="mb-10 font-thin text-center text-secondary lg:text-left text-3xl">
            We cover the following areas
          </div>

          <div className="grid grid-cols-2 gap-2 ">
            {areasCovered.map((area, index) => {
              return (
                <div className="font-light text-center  lg:text-left text-base lg:text-xl text-white">
                  {area}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurFleet;
